export const getTariffTranslationKey = (tariff) => {
    return `tariff_${ tariff }`
}

export const getOptionVersionTranslationKey = (option) => {
    return `${ option }_version`
}

